import { CompanyContextProvider } from 'contexts/CompanyContextProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './app/App';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import { enablePatches } from 'immer';

enablePatches();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <I18nextProvider i18n={i18n}>
    <React.StrictMode>
      <CompanyContextProvider>
        <Router>
          <App />
        </Router>
      </CompanyContextProvider>
    </React.StrictMode>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(c o n s o l e . l o g))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
